interface TableColumn {
  key: string;
  type: 'string' | 'number' | 'percentage' | 'currency';
}

// Checkout / Shipping Rates test columns
export const TABLE_HEADERS = ['variant', 'traffic%', 'checkouts', 'checkout CVR', 'AOV', 'Avg. Ship Rev', 'ARPC'];

export const TABLE_COLUMNS: TableColumn[] = [
  { key: 'traffic', type: 'percentage' },
  { key: 'checkouts', type: 'number' },
  { key: 'convRate', type: 'percentage' },
  { key: 'aov', type: 'currency' },
  { key: 'asr', type: 'currency' },
  { key: 'arpc', type: 'currency' },
];

// Cross-Site / Theme test columns
export const CROSS_SITE_TABLE_HEADERS = ['variant', 'traffic%', 'users', 'stat. sig.', 'CVR', 'AOV', 'ARPU'];

export const CROSS_SITE_TABLE_COLUMNS: TableColumn[] = [
  { key: 'traffic', type: 'percentage' },
  { key: 'users', type: 'number' },
  { key: 'statSig', type: 'percentage' },
  { key: 'cvr', type: 'percentage' },
  { key: 'aov', type: 'currency' },
  { key: 'arpu', type: 'currency' },
];

// Aliases for backward compatibility
export const CHECKOUT_TABLE_HEADERS = TABLE_HEADERS;
export const CHECKOUT_TABLE_COLUMNS = TABLE_COLUMNS;
